/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-12 11:02 am
 * Last Modified: Monday, 25-03-17 03:21 pm, by Harper Yan
 */

import { Logger } from '@web/utils';

export * from './screen';

export const logger = new Logger({
  module: '@ucard/ds',
});
